import { css } from 'linaria';

export const root = css`
    align-items: center;
    cursor: default;
    display: inline-flex;
    flex-shrink: 0;
`;

export const text = css`
    .${root} span &,
    .${root} span &:link {
        color: var(--r-text-secondary);
        font-weight: inherit;
        white-space: nowrap;
        text-decoration: none;
    }

    .${root} span &:link {
        cursor: pointer;
    }

    .${root} span &:link:hover {
        text-decoration: underline;
    }
`;

export const current = css`
    .${root} span & {
        color: var(--r-text-secondary-plus);
    }
`;

export const separator = css`
    align-items: center;
    display: inline-flex;
    justify-content: center;
    width: 36px;
`;

export const separatorIcon = css`
    height: 12px;
    width: 12px;
    color: var(--r-text-secondary);
`;
